import {
  Component,
  input,
  Input,
  InputSignal,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { SpinnerComponent } from '@shared/components/ui/spinner';
import { SkeletonLoaderComponent } from '@shared/components/ui/skeleton-loader';
import { SmoothSizeDirective } from '@shared/ui-directives';
import { TruncateTooltipDirective } from '@shared/directives';


@Component({
  selector: 'lib-button',
  imports: [NgClass, SpinnerComponent, SkeletonLoaderComponent, SmoothSizeDirective, TruncateTooltipDirective],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  standalone: true,
})
export class ButtonComponent {

  public disabled = input(false);
  /** The type of the button
   * @default 'primary'
   * */
  @Input()
  type: 'primary' | 'secondary' | 'destructive' | 'ghost' | 'ghost-inactive' | 'ghost-active'| 'warning'| 'link' | 'danger' | 'info' | 'success' | 'outline' | 'dashed' | 'pink' | 'purple' | 'orange' | 'lime' | 'emerald' | 'cyan' = 'primary';

  /** The state of the button
   * @default 'default'
   * */
  @Input()
  state: 'default' | 'disabled'  = 'default';

  /** The size of the button
   * @default 'default'
   * */
  @Input()
  size: 'large' | 'default' | 'small' = 'default';

  /** The screen of the button
   * @default 'default'
   * */
  @Input()
  screen: 'desktop' | 'mobile' = 'desktop';

  /** The icon of the button
   * This icon is based on the flat icon Interface lib
   * example: circle
   * @default ''
   * */
  @Input()
  icon?: string;

  /** The icon alignment of the button
   * @default 'left'
   * */
  @Input()
  iconAlign: 'left' | 'right' = 'left';


  /** The icon size of the button
   * @default '16px'
   * */
  @Input()
  iconSize: string = '16px';

  /**
   * The loading state of the button
   * */
  public loading = input(false);

  /**
   * Removes horizontal padding from the button
   * @default false
   */
  public readonly withoutXPadding = input(false);

  /**
 * The unique identifier of the button.
 * @default null
 */
  public readonly id: InputSignal<string> = input<string>();

  @Input() buttonType: 'button' | 'submit' = 'button';

  @Input() skeleton: boolean = false;

  /** The style of the button
 * @default 'default'
 * */
  @Input()
  style: 'squared' | 'rectangle' = 'rectangle';

  /** Custom CSS classes to apply to the button
   * Allows for additional styling exceptions
   * @default ''
   * */
  @Input()
  customClass: string = '';
}
